import React, { useEffect } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "../CSS/home.css";
import SubmissionForm from "../requests/RequestSubmissionForm";
import fightCovid2 from "../assets/Covid19-2.webp";
import fightCovid2Ios from "../assets/Covid19-2.png";
import Player from "../ui/player";
import homeback from "../assets/homeback2.webp";
import homebackIos from "../assets/homeback2.png";
import bloodDrop from "../assets/blood-donation.webp";
import bloodDropIos from "../assets/blood-donation.png";
import hand from "../assets/hand.webp";
import handIos from "../assets/hand.png";
import { Link } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import FlowChart from "../assets/HowItWorks.webp";
import FlowChartIos from "../assets/HowItWorks.png";
import FlowChartMobile from "../assets/HowItWorksMobile.webp";
import FlowChartMobileIos from "../assets/HowItWorksMobile.png";
import Swal from "sweetalert2";
// import { getDonorsCount, getActiveRequestsCount } from "../../api/stats";
// import { updateUserData } from "../../api/users";
// import Donut from "../ui/donut";
// import windowDimensions from "../utility/windowDimensions";


export default function Home() {

  // const { user }: any = useContext(AuthContext);
  // const { width } = windowDimensions();
  let sumbitContainerId = "Submit-container";
  // const [numberOfDonors, setNumberOfDonors] = useState(0);
  // const [numberOfActiveRequests, setNumberOfActiveRequests] = useState(0);
  // const labels = ["Donors", "Active Requests"];
  // const audio = new Audio(`${process.env.PUBLIC_URL}/badgeNotification.mp3`);
  // const kamehameha = new Audio(`${process.env.PUBLIC_URL}/good_kamehameha.mp3`);
  // const Toast = Swal.mixin({
  //   toast: true,
  //   position: 'top',
  //   showConfirmButton: false,
  //   timer: 3000,
  //   timerProgressBar: true,
  //   onOpen: (toast) => {
  //     toast.addEventListener('mouseenter', Swal.stopTimer)
  //     toast.addEventListener('mouseleave', Swal.resumeTimer)
  //   }
  // });

  useEffect(() => {
    // getActiveRequestsCount().then((value) => {
    //   setNumberOfActiveRequests(value);
    // })
    // getDonorsCount().then((value) => {
    //   setNumberOfDonors(value);
    // })
  //   if (user && user.details.cards.firstLogin && user.details.stats.timesLoggedIn === 0) {
  //     audio.play();
  //     Toast.fire({
  //         icon: 'success',
  //         title: 'New Card Unlocked'
  //       });
  //   }
  //   if (user && !user.details.cards.register) {
  //     audio.play();
  //     Toast.fire({
  //         icon: 'success',
  //         title: 'New Card Unlocked'
  //       });
  //     user.details.cards.register = true;
  //     updateUserData(user.details, user.uid, user.userType);
  // }
  // if (user && user.details.stats.requestsMade > 0 && !user.details.cards.firstRequest) {
  //   audio.play();
  //     Toast.fire({
  //         icon: 'success',
  //         title: 'New Card Unlocked'
  //       });
  //     user.details.cards.firstRequest = true;
  //     updateUserData(user.details, user.uid, user.userType);
  // }
  // if (user && !user.details.cards.gokuFound && user.details.stats.timesGokuClicked > 0) {
  //   kamehameha.play();
  //     Toast.fire({
  //         icon: 'success',
  //         title: 'New Card Unlocked'
  //       });
  //   user.details.cards.gokuFound = true;
  //   updateUserData(user.details, user.uid, user.userType);
  // }
  }, []);

  if (navigator.appVersion.indexOf("Mac") !== -1) sumbitContainerId = "Submit-container-mac";

  const infoSubmitOnClick = () => {
    Swal.fire({
      title: '<strong>What Happens When You Submit a Request?</strong>',
      icon: 'info',
      text: 'An in-app notifiction is sent to all the registered donors from your city who match the required blood type. Text messages are also sent periodically to users, depending upon the status of your request.',
      confirmButtonText:
        '<i class="fa fa-thumbs-up"></i> Great!',
      confirmButtonAriaLabel: 'Thumbs up, great!',
    })
  }
  const infoRequestListOnClick = () => {
    Swal.fire({
      title: '<strong>Can I See My Request?</strong>',
      icon: 'info',
      text: 'Yes. If you are a registered requester, you can view your request on your dashboard. If you are not registered, you can go to the request status page and enter the request ID to view the status of your request.',
      confirmButtonText:
        '<i class="fa fa-thumbs-up"></i> Great!',
      confirmButtonAriaLabel: 'Thumbs up, great!',
    })
  }
  const infoDonateOnClick = () => {
    Swal.fire({
      title: '<strong>How Does Donation Work?</strong>',
      icon: 'info',
      text: 'When you register yourself as a donor, you can see a "Requests" tab uplon logging in. Navigating to that will bring up a list of requests from your city that a compatible with your blood type. You will also periodically receive SMS and in-app notifications regarding blood requests.',
      confirmButtonText:
        '<i class="fa fa-thumbs-up"></i> Great!',
      confirmButtonAriaLabel: 'Thumbs up, great!',
    })
  }

  return (
    <AuthContext.Consumer>
      {({ user }: any) => (
        <div className="Home-wrapper">
          <div className="home-main">
            <div className="home-main-sub">
              <div className="home-main-heading">
                <h2 id="home-text-donate" className="home-main-heading-text">DONATE</h2>
                <h2 className="home-main-heading-text">And Save</h2>
                <h2 id="home-text-lives" className="home-main-heading-text">Lives.</h2>
              </div>
              <div className="home-main-button-div">
                {user && user.userType === "requester" ? 
                  <Link className="action-button donate-blood-button" to="/dashboard">
                    DASHBOARD
                  </Link>
                  : user ? null :
                  <Link className="action-button donate-blood-button" to="/register">
                    <picture>
                      <source className="home-buttons-icons" srcSet={hand} type="image/webp" />
                      <source className="home-buttons-icons" srcSet={handIos} type="image/png" />
                      <img className="home-buttons-icons" src={hand} alt="icon" />
                    </picture>
                    DONATE BLOOD
                  </Link>
                }
                {user && user.userType === "requester" ? null : 
                 user && user.userType === "donor" ? 
                 <Link to="/requests" className="action-button request-blood-button">
                    <i className="fas fa-heartbeat"></i> REQUESTS
                  </Link>
                  :
                  <a href="#Submit-container" className="action-button request-blood-button">
                    <picture>
                      <source srcSet={bloodDrop} type="image/webp" />
                      <source srcSet={bloodDropIos} type="image/png" />
                      <img className="home-buttons-icons" src={bloodDrop} alt="icon" />
                    </picture>
                    REQUEST BLOOD
                  </a>
                }
              </div>
            </div>
            <picture style={{marginTop: "auto"}}>
              <source className="home-main-image" srcSet={homeback} type="image/webp" />
              <source className="home-main-image" srcSet={homebackIos} type="image/png" />
              <img className="home-main-image" src={homeback} alt="icon" />
            </picture>
          </div>
          {/* <div className="home-stats">
            <ScrollAnimation animateOnce={true} animateIn="slideInLeft">
              <Donut series={[numberOfDonors, numberOfActiveRequests]} labels={labels} showTotal={false} />
            </ ScrollAnimation>
            <p className="home-stats-text">
              Madadgaar aims to make donor-recipient connection both safe and fast. 
              If any hospital/doctor/individual is in search of a donor, they will go to Madadgaar 
              and log a request. Subsequently, an SMS/notification will be sent to all the donors 
              of the compatible blood groups in the city. 
            </p>
          </div> */}
            <div className="hiw-img-container">
            <picture>
              <source media="(min-width:750px)" className="hiw-img" srcSet={FlowChart} type="image/webp" />
              <source media="(max-width:500px)" className="hiw-img" srcSet={FlowChartMobile} type="image/webp" />
              <source media="(min-width:750px)" className="hiw-img" srcSet={FlowChartIos} type="image/png" />
              <source media="(max-width:500px)" className="hiw-img" srcSet={FlowChartMobileIos} type="image/png" />
              <img className="hiw-img" src={FlowChart} alt="Flow Chart" />
            </picture>
            </div>
          {user && user.userType === "requester" ? null : 
            <header className="App-header">
              <div id={sumbitContainerId}>
                <SubmissionForm id="submission-inner-container" class="container bg-white p-5" />
              </div>
            </header>
          }
          <ScrollAnimation animateOnce={true} animateIn="slideInLeft">
            <div id="Info-boxes" className="container">
              <div onClick={infoSubmitOnClick} className="Info-box">
                <h3>
                  <i className="fab fa-wpforms"></i> Submit Request
                </h3>
                <p>
                  A message will be sent to the number provided for
                  verification. Maximum of 1 active request per unregistered user, and
                  10 active requests per organization.
                </p>
              </div>
              <div onClick={infoRequestListOnClick} className="Info-box">
                <h3>
                  <i className="fas fa-clipboard-list"></i> Request List
                </h3>
                <p>
                  You can view a list of all compatible blood requests after signing up.
                </p>
              </div>
              <div onClick={infoDonateOnClick} className="Info-box">
                <h3>
                  <i className="fas fa-hand-holding-medical"></i> How to Donate?
                </h3>
                <p>
                  When you register as a Donor or Requester, you will recieve a
                  notification or SMS from us when a compatible blood request is
                  generated.
                </p>
              </div>
            </div>
          </ScrollAnimation>
          <Player />
          <div id="covid-container" className="container">
            <ScrollAnimation animateOnce={true} animateIn="fadeIn">
            <picture>
              <source className="home-image" srcSet={fightCovid2} type="image/webp" />
              <source className="home-image" srcSet={fightCovid2Ios} type="image/png" />
              <img className="home-image" src={fightCovid2} alt="Fight Covid" />
            </picture>
            </ScrollAnimation>
          </div>
        </div>
      )}
    </AuthContext.Consumer>
  );
}
